import {
  fetchPostCheckoutChargeWithRetry,
} from "apps/website/utils/fetch-post-checkout-charge";

import { TrackerContext } from "../../types";
import { SourceHandler } from "../types";

export const getFirstOrderHandler: SourceHandler = async (
  api,
  context: TrackerContext,
  setter,
) => {
  if (context.sources.firstOrder !== undefined) {
    return;
  }

  const katkinCustomerId = context.query.get("katkinCustomerId");

  if (!katkinCustomerId || Array.isArray(katkinCustomerId)) {
    console.error("no katkinCustomerId provided. katkinCustomerId=", katkinCustomerId);
    return;
  }

  const res = await fetchPostCheckoutChargeWithRetry(api, true, katkinCustomerId);

  if (res) {
    setter((old) => ({ ...old, firstOrder: res }));
  }
};
